import { ReactNode } from 'react';
import { Wrapper } from './styles';

type FormDividerType = {
  children: ReactNode;
};

export const FormDivider = ({ children }: FormDividerType) => {
  return <Wrapper>{children}</Wrapper>;
};
